export const GENERATION_ENDPOINTS = [
	'/v1/pipes/run',
	'/beta/chat',
	'/beta/generate',
	'/v1/agent/run',
];
